import { render, staticRenderFns } from "./CodaPay.vue?vue&type=template&id=d12b89f2&scoped=true"
import script from "./CodaPay.vue?vue&type=script&lang=js"
export * from "./CodaPay.vue?vue&type=script&lang=js"
import style0 from "./CodaPay.vue?vue&type=style&index=0&id=d12b89f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12b89f2",
  null
  
)

export default component.exports